import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import {
  CategorySelfStudyDTO,
  ListCategorySelfStudyDTO,
  ListSelfStudyDocumentDTO,
  SelfStudyDocumentDTO,
} from 'src/app/model/newModel';
import { SelfStudyService } from './self-study.service';

@Component({
  selector: 'app-self-study',
  templateUrl: './self-study.component.html',
  styleUrls: ['./self-study.component.css'],
})
export class SelfStudyComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  listSelfStudyDocuments: SelfStudyDocumentDTO[];
  listSelfStudyCategories: CategorySelfStudyDTO[];

  ngOnInit(): void {
    super.ngOnInit();
    this.loadCategoriesSelfStudy();
    this.loadDocumentsSelfStudy();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  loadCategoriesSelfStudy() {
    this.selfStudyService.loadCategoriesSelfStudy().subscribe(
      (result: ListCategorySelfStudyDTO) => {
        this.listSelfStudyCategories = result.categoriesSelfStudy;
      },
      (error) => {
        console.log('Errore loadCategoriesSelfStudy');
      }
    );
  }

  loadDocumentsSelfStudy() {
    this.selfStudyService.loadDocumentsSelfStudy().subscribe(
      (result: ListSelfStudyDocumentDTO) => {
        this.listSelfStudyDocuments = result.selfStudyDocuments;
      },
      (error) => {
        console.log('Errore loadDocumentsSelfStudy');
      }
    );
  }

  constructor(private selfStudyService: SelfStudyService) {
    super();
  }
}
